import React from "react";

export default function About() {
  return (
    <section id="about">
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            Hi, I'm Dennis.
            <br className="hidden lg:inline-block" /> I'm a spatial analyist and data engineer and I love building amazing apps.
          </h1>
          <p className="mb-8 leading-relaxed">
            I've had a fascination with science and technology for as long as I can remember. 
            In elementrary school I launched model rockets with my dad and built AOL proggs. 
            In high school I took a class on how to build a computer from scratch which then lead me to modding XBoxs. 
            I discovered data science in college when I took a course on Geographic Information Systems which lead me to Python, R, and SQL in other classes.
            <br className="hidden lg:inline-block" />
            <br className="hidden lg:inline-block" />
            I joined NOAA in 2017 building a geo-spatial database of sea turtle nesting beaches along the East Coast. 
            After that, I took on another project building an R package to automate socioeconomic reports for the planning of offshore wind developments. 
            The package was shared on GitHub with several regional NOAA Science Center teams across the country as a template to aid in their wind energy development efforts.
            <br className="hidden lg:inline-block" />
            <br className="hidden lg:inline-block" />
            Outside of NOAA I've built websites for 2 small businesses and worked on several hobby projects.
          </p>
          <div className="flex justify-center">
            <a
              href="#contact"
              className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
              Work With Me
            </a>
            <a
              href="#projects"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
              See My Past Work
            </a>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            className="object-cover object-center rounded"
            alt="coder"
            src="./coding.svg"
          />
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/About.js